import { render, staticRenderFns } from "./index_dis.vue?vue&type=template&id=32d8230b&scoped=true"
import script from "./index_dis.vue?vue&type=script&lang=js"
export * from "./index_dis.vue?vue&type=script&lang=js"
import style0 from "./index_dis.vue?vue&type=style&index=0&id=32d8230b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d8230b",
  null
  
)

export default component.exports